/** หมู่บ้านหยานหยู, the starting village by the sea: a gentle zheng song with a dizi, waves on the shore. */
import { arp, drone, vary } from '../compose';
import { registerTrack } from '../registry';

const A = `@mf 3_ 5_ 6 1'. 6_ | 5_ 6_ 5_ 3_ 2-~ | 3_ 5_ 6_ 1'_ 2'. 3'_ | 2'_ 1'_ 6~ 5- |
  6_ 1'_ 2' 3'_ 5'_ 3' | 2'_ 3'_ 2'_ 1'_ 6 5/ | 3_ 5_ 6_ 5_ 3_ 2_ 1_ 2_ | 1g-~--`;
const A2 = vary(A, 6, `3_ 2_ 1_ 6,_ 5,_ 6,_ 1_ 2_`, `1G-~--`);
const ROOTS_A = `1, 5,, 6,, 5,, 6,, 2, 5,, 1,`;

const B_DIZI = `@mp 6. 1'_ 2' 3' | 5'_ 3'_ 2' 1'- | 6 1'_ 6_ 5 3 | 2-- 0 ; |
  3_ 5_ 6_ 1'_ 2'. 1'_ | 6_ 1'_ 5_ 6_ 3- | 2_ 3_ 5_ 6_ 5_ 3_ 2_ 3_ | 1-~--`;
const B_ZHENG = `@mp 6,&3~-- 0 | 5,&2-- 0 | 6,&3-- 0 | 5,&2%--- | 3,&6,\\-- 0 | 6,,&3,-- 0 | 5,&2-- 0 | 1&5%---`;
const ROOTS_B = `6,, 5,, 6,, 5,, 3,, 6,, 5,, 1,`;

// C: the tide goes out: the zheng alone, high and slow, with harmonics and long presses.
const C = `@mp 5'* 3'* 2'- | 1'_ 2'_ 3'_ 5'_ 6'- | 5'_ 3'_ 2' 3'^- | 2'-- 0 |
  6_ 1'_ 2'_ 3'_ 2' 1' | 6_ 5_ 6 1'- | 2'_ 1'_ 6_ 5_ 3 2 | 3-~ 0-`;
const ROOTS_C = `1, 1, 6,, 2, 6,, 5,, 2, 3,`;

const FLOW = [0, 3, 5, 6, 7, 6, 5, 3];
const LAP = [0, null, 3, 5, null, 3, 5, 3];

registerTrack({
  id: 'yanyu',
  order: 3,
  title: 'คลื่นกระซิบหน้าหมู่บ้าน',
  mood: 'อ่อนโยน สดใส ลมทะเล',
  use: 'หมู่บ้านหยานหยู (หมู่บ้านเริ่มต้นริมทะเล)',
  key: 'D',
  mode: 'gong',
  bpm: 76,
  meter: 4,
  seed: 301,
  humanize: 0.5,
  parts: {
    zheng: { inst: 'zheng', pan: 0.12, reverb: 0.3 },
    bass: { inst: 'zheng', gain: 0.5, pan: -0.25, reverb: 0.25 },
    dizi: { inst: 'dizi', gain: 0.9, pan: -0.1, reverb: 0.4 },
    pad: { inst: 'pad', gain: 0.8, reverb: 0.5 },
    sea: { inst: 'perc', gain: 0.35, pan: 0.3, reverb: 0.2 },
  },
  intro: ['I'],
  sections: {
    I: {
      bars: 2,
      parts: {
        zheng: `@mp 0- 5g- | 1'-~--`,
        sea: `w--- | 0---`,
        pad: drone('1, 1,', 4),
      },
    },
    A: {
      bars: 8,
      parts: {
        zheng: A,
        bass: arp(ROOTS_A, FLOW),
        pad: drone(ROOTS_A, 4),
        sea: `w--- | 0--- | 0--- | 0--- | w--- | 0--- | 0--- | 0---`,
      },
    },
    B: {
      bars: 8,
      parts: {
        dizi: B_DIZI,
        zheng: B_ZHENG,
        bass: arp(ROOTS_B, LAP),
        pad: drone(ROOTS_B, 4),
        sea: `0--- | 0--- | w--- | 0--- | 0--- | 0--- | w--- | 0---`,
      },
    },
    A2: {
      bars: 8,
      parts: {
        zheng: A2,
        dizi: `@p 0--- | 0--- | 0--- | 0--- | 6_ 1'_ 2' 3'_ 5'_ 3' | 2'_ 3'_ 2'_ 1'_ 6 5 | 3_ 5_ 6_ 5_ 3_ 2_ 1_ 2_ | 1---`,
        bass: arp(ROOTS_A, FLOW),
        pad: drone(ROOTS_A, 4),
        sea: `w--- | 0--- | 0--- | 0--- | w--- | 0--- | 0--- | 0---`,
      },
    },
    C: {
      bars: 8,
      bpm: 70,
      parts: {
        zheng: C,
        bass: arp(ROOTS_C, [0, null, null, 3, null, null, 5, null]),
        pad: drone(ROOTS_C, 4),
        sea: `w--- | 0--- | 0--- | w--- | 0--- | 0--- | w--- | 0---`,
      },
    },
  },
  form: ['A', 'B', 'A2', 'C', 'B', 'A2'],
  loop: true,
});
